<template>
  <div>
    {{days}}:{{hours}}:{{minutes}}
  </div>
</template>

<script>
  import timerMixin from '@/mixins/timerMixin'

  export default {
    name: 'VacancyActualTimer',
    mixins: [timerMixin],
    data() {
      return {

      }
    }
  }
</script>

<style lang="less">

</style>
